/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAnalyticsFollowersListResponse } from '../../models/profile-analytics-followers-list-response';

export interface ProfileFollowerList$Params {
  id: number;
  offset: number;
  limit: number;
}

export function profileFollowerList(http: HttpClient, rootUrl: string, params: ProfileFollowerList$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsFollowersListResponse>> {
  const rb = new RequestBuilder(rootUrl, profileFollowerList.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('offset', params.offset, {});
    rb.path('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileAnalyticsFollowersListResponse>;
    })
  );
}

profileFollowerList.PATH = '/rest/profile/{id}/analytics/followers/list/{offset}/{limit}';
